import React from "react";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Partners } from "./components/Partners";
import { WhyChooseUs } from "./components/WhyChooseUs";
import { Process } from "./components/Process";
import { Reviews } from "./components/Reviews";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { StickyCallButton } from "./components/StickyCallButton";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <Partners />
      <WhyChooseUs />
      <Process />
      <Reviews />
      <Contact />
      <Footer />
      <StickyCallButton />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
